module.exports = __webpack_public_path__ + "img/bell.00611374.svg";